export default "__VITE_ASSET__BjdleQTi__"